import React from "react";
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import Button from "../../../components/buttons/Button";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import InputField from "../../../components/inputFields/InputField";
import { toast } from "react-toastify";
import { addHudPatientPackage, patchHudPatientPackage } from "../../../services/hud/hud_patients";
import FormikDropdown from "../../../components/inputFields/FormikDropDown";
import { pricesColorCoding } from "../../../constants/prices_colors_coding";

const AddUpdatePackage = ({ patientId, onAddNewPackage, initialValues = null }) => {
    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const response = initialValues.package_id ? await patchHudPatientPackage(patientId, initialValues.package_id, values) : await addHudPatientPackage(patientId, values);
            if (response?.status === 201 || response?.status === 200) {
                onAddNewPackage();
                toast.success(initialValues ? "Package updated successfully" : "Package added successfully!");
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        package_name: Yup.string().required("Package is required"),
        package_status: Yup.string().required("Type is required"),
        amount: Yup.string().required("Amount is required"),
    });

    return (
        <>
            <div className="w-full flex-1">
                <StyledHeadingText text="Add New Package" />
                <Formik
                    initialValues={{
                        package_name: "FULL BODY",
                        package_status: "Paid",
                        // date: new Date().toISOString().split("T")[0],
                        amount: 10000,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, setFieldValue, values }) => (
                        <Form className="space-y-2 my-4">
                            <div className="flex flex-col">
                                <FormikDropdown
                                    label="Package Type"
                                    name="package_name"
                                    placeholder="Select Package"
                                    required={true}
                                    options={[
                                        { label: "TPT", value: "TPT" },
                                        { label: "HPF", value: "HPF" },
                                        { label: "FULL BODY", value: "FULL BODY" },
                                        { label: "HAND", value: "HAND" },
                                        { label: "FEET", value: "FEET" },
                                    ]}
                                />
                                <FormikDropdown
                                    label="Package Status"
                                    name="package_status"
                                    placeholder="Select Type"
                                    required={true}
                                    options={[
                                        { label: "Paid", value: "Paid" },
                                        { label: "FOC", value: "FOC" },
                                    ]}
                                    onChange={(value) => {
                                        if (value.value === "FOC") {
                                            setFieldValue("amount", 0);
                                        } else {
                                            setFieldValue("amount", "");
                                        }
                                    }}
                                />
                                {/* <InputField
                                    label="Date"
                                    name="date"
                                    type="date"
                                    placeholder="Select Date"
                                    required
                                /> */}
                                <FormikDropdown
                                    label="Package Color"
                                    name="amount"
                                    placeholder="Select Amount"
                                    required={true}
                                    disabled={values.package_status === "FOC"}
                                    options={pricesColorCoding.map((val) => ({
                                        label: `${val.title} (${val.short_hand})`,
                                        value: val.amount,
                                    }))}
                                />
                                <Button
                                    type="submit"
                                    className="bg-primary text-white px-4 py-2 rounded max-w-32"
                                    disabled={isSubmitting}
                                >
                                    {initialValues.package_id ? isSubmitting ? "Updating..." : "Update" : isSubmitting ? "Adding..." : "Add"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div >
        </>
    );
};

export default AddUpdatePackage;
